import { render, staticRenderFns } from "./AppointmentManagementCard.vue?vue&type=template&id=148a8813"
import script from "./AppointmentManagementCard.vue?vue&type=script&lang=ts"
export * from "./AppointmentManagementCard.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentManagementCard.vue?vue&type=style&index=0&id=148a8813&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports